import React from "react";
import TopNavTabs from "./TopNavTabs";
import { isZh } from "../utils/language";

export default function SongsTopBar({
  mode,
  setMode,
  searchValue,
  setSearchValue,
  setShowDialog,
  selectedPlaylist,
  setSelectedPlaylist,
  setFilters,
  setAppliedFilters,  
  rows,
  isMobile,
  canEdit
}) {
  const tabItems = [
    { key: "album", label: isZh() ? "專輯" : "Album" },
    { key: "song", label: isZh() ? "搜尋歌曲" : "Cari Lagu" },
    ...(canEdit
      ? [{ key: "daftar", label: isZh() ? "歌曲列表" : "Daftar Lagu" }]
      : [])
  ];

  return (
    <div style={{ marginBottom: 16 }}>
      <TopNavTabs
        items={tabItems}
        activeKey={mode}
        onTabClick={(key) => {
          setMode(key);

          // reset state
          setSelectedPlaylist(null);
          setSearchValue("");

          const empty = {
            primary_language: [],
            emotion_tags: [],
            keyword_tags: []
          };

          setFilters(empty);
          setAppliedFilters(empty);
        }}
      />

      {/* ================= PLAYLIST TITLE ================= */}
      {mode === "album" && selectedPlaylist && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginTop: 8,
            marginBottom: 8
          }}
        >
          <button
            className="btn-secondary"
            onClick={() => setSelectedPlaylist(null)}
          >
            ←
          </button>

          <div style={{ fontWeight: 700, fontSize: 18 }}>
            {isZh()
              ? selectedPlaylist.title_zh
              : selectedPlaylist.title_id}
            <span
              style={{
                marginLeft: 8,
                fontSize: "0.875rem",
                color: "#666"
              }}
            >
              {isZh()
                ? `(共 ${selectedPlaylist?.song_playlist_items?.length || 0} 首)`
                : `(${selectedPlaylist?.song_playlist_items?.length || 0} lagu)`}
            </span>
          </div>
        </div>
      )}

      {/* ================= SEARCH ================= */}
      {(mode === "song"  || mode === "daftar" || selectedPlaylist) && (
        <div style={{ display: "flex", gap: 8 }}>
          <input
            type="search"
            placeholder={
              isZh()
                ? "搜尋歌曲（至少1個漢字）"
                : "Cari lagu (min. 3 huruf latin / 1 huruf Mandarin)"
            }
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            style={{
              flex: 1,
              marginTop: "5px",
              padding: "10px 14px",
              borderRadius: 10,
              border: "1px solid #ddd"
            }}
          />

          {mode === "song" && isMobile && (
            <button onClick={() => setShowDialog("filter")}>⚙️</button>
          )}
        </div>
      )}
    </div>
  );
}